export default __webpack_public_path__ + "static/media/Raider's Wristbands of the Howling Wind.6b409693.jpg";